import React from "react";
import styles from "./Graph.module.scss"

export default function AffaireHuawei() {
    const svg = `
<svg width="1411px" height="571px" viewBox="0 0 1411 571" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <polygon id="path-7e9t8tn9_1-1" points="0 0 1410.44379 5.30952454 1410.44379 570.127319 0 570.127319"></polygon>
    </defs>
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Bloc-Time-Line" transform="translate(0.000000, 0.794800)">
            <g id="Line-Copy" transform="translate(0.000000, -0.000000)">
               
                <g id="Mask"></g>
                <path d="M1002.24551,-629.613312 C1002.24551,-583.740143 1002.24551,-500.456553 1002.24551,-379.762543 L1002.24551,-377.569672 C1002.24551,-322.341197 957.473989,-277.569672 902.245514,-277.569672 C902.183032,-277.569672 902.120549,-277.569731 902.058067,-277.569848 L568.949074,-278.194251 C513.720696,-278.297775 468.865327,-233.610252 468.761803,-178.381874 C468.761686,-178.319391 468.761627,-178.256909 468.761627,-178.194427 L468.761627,22.4303277 C468.761627,77.6588027 513.533152,122.430328 568.761627,122.430328 C568.824109,122.430328 568.886592,122.430269 568.949074,122.430152 L902.058067,121.805749 C957.286445,121.702225 1002.14181,166.389748 1002.24534,221.618126 C1002.24546,221.680609 1002.24551,221.743091 1002.24551,221.805573 L1002.24551,422.61795 C1002.24551,477.846425 957.473989,522.61795 902.245514,522.61795 L568.761627,522.61795 C513.533152,522.61795 468.761627,567.389475 468.761627,622.61795 L468.761627,802.61795 L468.761627,1072.39383 L468.761627,1193.39383 L468.761627,1193.39383" stroke="#13C636" stroke-width="2" stroke-linecap="square" mask="url(#mask-7e9t8tn9_1-2)" transform="translate(735.503571, 281.890259) scale(-1, -1) rotate(90.000000) translate(-735.503571, -281.890259) "></path>
            </g>
            <g id="2016-A" transform="translate(151.231262, 70.205200)">
                <g id="Titre" transform="translate(69.000000, 0.000000)" line-spacing="16">
                    <text id="La-directrice-financ" font-family="Madera-Regular, Madera" font-size="12" font-weight="normal" fill="#000000">
                        <tspan x="0" y="36">La directrice financière du géant des </tspan>
                        <tspan x="0" y="52">télécoms, Meng Wanzhou, est arrêtée au </tspan>
                        <tspan x="0" y="68">Canada sur mandat d’arrêt américain, </tspan>
                        <tspan x="0" y="84">sur la base d’accusations de fraudes </tspan>
                        <tspan x="0" y="100">bancaires. Il est question de « fausses </tspan>
                        <tspan x="0" y="116">déclarations » faites à un cadre de HSBC </tspan>
                        <tspan x="0" y="132">sur les « activités de Huawei en Iran ».</tspan>
                    </text>
                    <text id="Décembre" font-family="Madera-Bold, Madera" font-size="14" font-weight="bold" fill="#13C636">
                        <tspan x="0" y="18">Décembre</tspan>
                    </text>
                </g>
                <g id="Picto-date" transform="translate(0.000000, 4.000000)">
                    <circle id="Oval" fill="#13C636" cx="25" cy="25" r="25"></circle>
                    <text id="2018" font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="17" font-weight="bold" line-spacing="17" letter-spacing="-0.944444444" fill="#FFFFFF">
                        <tspan x="7.99631076" y="30">2018</tspan>
                    </text>
                </g>
            </g>
            <g id="2016-A-Copy" transform="translate(151.231262, 237.205200)">
                <g id="Titre" transform="translate(69.000000, 0.000000)" line-spacing="16">
                    <text id="Le-Département-de-la" font-family="Madera-Regular, Madera" font-size="12" font-weight="normal" fill="#000000">
                        <tspan x="0" y="36">Le Département de la justice inculpe </tspan>
                        <tspan x="0" y="52">Huawei d'espionnage industriel et de </tspan>
                        <tspan x="0" y="68">fraude.</tspan>
                    </text>
                    <text id="Janvier" font-family="Madera-Bold, Madera" font-size="14" font-weight="bold" fill="#13C636">
                        <tspan x="0" y="18">Janvier</tspan>
                    </text>
                </g>
                <g id="Picto-date" transform="translate(0.000000, 4.000000)">
                    <circle id="Oval" fill="#13C636" cx="25" cy="25" r="25"></circle>
                    <text id="2019" font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="17" font-weight="bold" line-spacing="17" letter-spacing="-0.944444444" fill="#FFFFFF">
                        <tspan x="7.99631076" y="30">2019</tspan>
                    </text>
                </g>
            </g>
            <g id="2016-A-Copy-2" transform="translate(151.231262, 341.205200)">
                <g id="Titre" transform="translate(69.000000, 0.000000)" line-spacing="16">
                    <text id="Donald-Trump-place-H" font-family="Madera-Regular, Madera" font-size="12" font-weight="normal" fill="#000000">
                        <tspan x="0" y="36">Donald Trump place Huawei liste noire, </tspan>
                        <tspan x="0" y="52">bloquant par décret les relations </tspan>
                        <tspan x="0" y="68">commerciales entretenues avec Google </tspan>
                        <tspan x="0" y="84">et divers fournisseurs de semi-</tspan>
                        <tspan x="0" y="100">conducteurs. Les fournisseurs </tspan>
                        <tspan x="0" y="116">américains qui souhaitent travailler avec </tspan>
                        <tspan x="0" y="132">Huawei doivent déposer une demande </tspan>
                        <tspan x="0" y="148">de licence.</tspan>
                    </text>
                    <text id="Mai" font-family="Madera-Bold, Madera" font-size="14" font-weight="bold" fill="#13C636">
                        <tspan x="0" y="18">Mai</tspan>
                    </text>
                </g>
                <g id="Picto-date" transform="translate(0.000000, 4.000000)">
                    <circle id="Oval" fill="#13C636" cx="25" cy="25" r="25"></circle>
                    <text id="2019" font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="17" font-weight="bold" line-spacing="17" letter-spacing="-0.944444444" fill="#FFFFFF">
                        <tspan x="7.99631076" y="30">2019</tspan>
                    </text>
                </g>
            </g>
            <g id="2016-A-Copy-5" transform="translate(550.231262, 70.205200)">
                <g id="Titre" transform="translate(69.000000, 0.000000)" line-spacing="16">
                    <text id="Malgré-l’arrivée-au" font-family="Madera-Regular, Madera" font-size="12" font-weight="normal" fill="#000000">
                        <tspan x="0" y="36">Malgré l’arrivée au pouvoir de Joe Biden, </tspan>
                        <tspan x="0" y="52">Huawei reste sur la liste noire </tspan>
                        <tspan x="0" y="68">américaine. Le patron de Huawei, Ren </tspan>
                        <tspan x="0" y="84">Zhengfei, appelle l’administration Biden </tspan>
                        <tspan x="0" y="100">à « une politique d’ouverture ».</tspan>
                    </text>
                    <text id="Février" font-family="Madera-Bold, Madera" font-size="14" font-weight="bold" fill="#13C636">
                        <tspan x="0" y="18">Février</tspan>
                    </text>
                </g>
                <g id="Picto-date" transform="translate(0.000000, 4.000000)">
                    <circle id="Oval" fill="#13C636" cx="25" cy="25" r="25"></circle>
                    <text id="2021" font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="17" font-weight="bold" line-spacing="17" letter-spacing="-0.944444444" fill="#FFFFFF">
                        <tspan x="7.99631076" y="30">2021</tspan>
                    </text>
                </g>
            </g>
            <g id="2016-A-Copy-8" transform="translate(950.231262, 326.205200)">
                <g id="Titre" transform="translate(69.000000, 0.000000)" line-spacing="16">
                    <text id="Les-Etats-Unis-assou" font-family="Madera-Regular, Madera" font-size="12" font-weight="normal" fill="#000000">
                        <tspan x="0" y="36">Les Etats-Unis assouplissent légèrement </tspan>
                        <tspan x="0" y="52">les sanctions contre Huawei, imposées </tspan>
                        <tspan x="0" y="68">par la précédente administration de </tspan>
                        <tspan x="0" y="84">Donald Trump. Les règles américaines </tspan>
                        <tspan x="0" y="100">restent toutefois les mêmes, empêchant </tspan>
                        <tspan x="0" y="116">le géant chinois de préinstaller les </tspan>
                        <tspan x="0" y="132">applications et services de Google sur </tspan>
                        <tspan x="0" y="148">ses smartphones et de s’approvisionner </tspan>
                        <tspan x="0" y="164">en puces 5G.</tspan>
                    </text>
                    <text id="Septembre" font-family="Madera-Bold, Madera" font-size="14" font-weight="bold" fill="#13C636">
                        <tspan x="0" y="18">Septembre</tspan>
                    </text>
                </g>
                <g id="Picto-date" transform="translate(0.000000, 4.000000)">
                    <circle id="Oval" fill="#13C636" cx="25" cy="25" r="25"></circle>
                    <text id="2022" font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="17" font-weight="bold" line-spacing="17" letter-spacing="-0.944444444" fill="#FFFFFF">
                        <tspan x="7.99631076" y="30">2022</tspan>
                    </text>
                </g>
            </g>
            <g id="2016-A-Copy-6" transform="translate(950.231262, 70.205200)">
                <g id="Titre" transform="translate(69.000000, 0.000000)" line-spacing="16">
                    <text id="Xiaomi-est-retiré-de" font-family="Madera-Regular, Madera" font-size="12" font-weight="normal" fill="#000000">
                        <tspan x="0" y="36">Xiaomi est retiré de la liste noire de </tspan>
                        <tspan x="0" y="52">Trump. En revanche, le régulateur </tspan>
                        <tspan x="0" y="68">américain des télécoms classe plusieurs </tspan>
                        <tspan x="0" y="84">entreprises chinoises d’équipements, </tspan>
                        <tspan x="0" y="100">dont Huawei, comme une menace pour </tspan>
                        <tspan x="0" y="116">la sécurité nationale.</tspan>
                    </text>
                    <text id="Mars" font-family="Madera-Bold, Madera" font-size="14" font-weight="bold" fill="#13C636">
                        <tspan x="0" y="18">Mars</tspan>
                    </text>
                </g>
                <g id="Picto-date" transform="translate(0.000000, 4.000000)">
                    <circle id="Oval" fill="#13C636" cx="25" cy="25" r="25"></circle>
                    <text id="2021" font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="17" font-weight="bold" line-spacing="17" letter-spacing="-0.944444444" fill="#FFFFFF">
                        <tspan x="7.99631076" y="30">2021</tspan>
                    </text>
                </g>
            </g>
            <g id="2016-A-Copy-7" transform="translate(950.231262, 222.205200)">
                <g id="Titre" transform="translate(69.000000, 0.000000)" line-spacing="16">
                    <text id="Meng-Wanzhou-est-lib" font-family="Madera-Regular, Madera" font-size="12" font-weight="normal" fill="#000000">
                        <tspan x="0" y="36">Meng Wanzhou est libérée après trois </tspan>
                        <tspan x="0" y="52">années passées en résidence surveillée </tspan>
                        <tspan x="0" y="68">au Canada.</tspan>
                    </text>
                    <text id="Septembre" font-family="Madera-Bold, Madera" font-size="14" font-weight="bold" fill="#13C636">
                        <tspan x="0" y="18">Septembre</tspan>
                    </text>
                </g>
                <g id="Picto-date" transform="translate(0.000000, 4.000000)">
                    <circle id="Oval" fill="#13C636" cx="25" cy="25" r="25"></circle>
                    <text id="2021" font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="17" font-weight="bold" line-spacing="17" letter-spacing="-0.944444444" fill="#FFFFFF">
                        <tspan x="7.99631076" y="30">2021</tspan>
                    </text>
                </g>
            </g>
            <g id="2016-A-Copy-3" transform="translate(550.231262, 361.205200)">
                <g id="Titre" transform="translate(69.000000, 0.000000)" line-spacing="16">
                    <text id="Huawei-choisit-Qwant" font-family="Madera-Regular, Madera" font-size="12" font-weight="normal" fill="#000000">
                        <tspan x="0" y="36">Huawei choisit Qwant pour devenir le </tspan>
                        <tspan x="0" y="52">moteur de recherche par défaut de ses </tspan>
                        <tspan x="0" y="68">téléphones mobiles.</tspan>
                    </text>
                    <text id="Mars" font-family="Madera-Bold, Madera" font-size="14" font-weight="bold" fill="#13C636">
                        <tspan x="0" y="18">Mars</tspan>
                    </text>
                </g>
                <g id="Picto-date" transform="translate(0.000000, 4.000000)">
                    <circle id="Oval" fill="#13C636" cx="25" cy="25" r="25"></circle>
                    <text id="2020" font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="17" font-weight="bold" line-spacing="17" letter-spacing="-0.944444444" fill="#FFFFFF">
                        <tspan x="7.99631076" y="30">2020</tspan>
                    </text>
                </g>
            </g>
            <g id="2016-A-Copy-4" transform="translate(550.231262, 205.205200)">
                <g id="Titre" transform="translate(69.000000, 0.000000)" line-spacing="16">
                    <text id="Selon-l’agence-Reute" font-family="Madera-Regular, Madera" font-size="12" font-weight="normal" fill="#000000">
                        <tspan x="0" y="36">Selon l’agence Reuters, les Etats-Unis ont </tspan>
                        <tspan x="0" y="52">accordé 113 licences d'exportation durant </tspan>
                        <tspan x="0" y="68">cette période à des fournisseurs </tspan>
                        <tspan x="0" y="84">souhaitant vendre des technologies à </tspan>
                        <tspan x="0" y="100">Huawei.</tspan>
                    </text>
                    <text id="Entre-Novembre-et-Av" font-family="Madera-Bold, Madera" font-size="14" font-weight="bold" fill="#13C636">
                        <tspan x="0" y="18">Entre Novembre et Avril</tspan>
                    </text>
                </g>
                <rect id="Rectangle" fill="#13C636" x="0" y="0" width="50" height="116" rx="25"></rect>
                <g id="Picto-date" transform="translate(0.000000, 66.000000)">
                    <circle id="Oval" fill="#13C636" cx="25" cy="25" r="25"></circle>
                    <text id="2020" font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="17" font-weight="bold" line-spacing="17" letter-spacing="-0.944444444" fill="#FFFFFF">
                        <tspan x="7.99631076" y="30">2020</tspan>
                    </text>
                </g>
                <g id="Picto-date-Copy">
                    <circle id="Oval" fill="#13C636" cx="25" cy="25" r="25"></circle>
                    <text id="2021" font-family="DINNextLTPro-Bold, DIN Next LT Pro" font-size="17" font-weight="bold" line-spacing="17" letter-spacing="-0.944444444" fill="#FFFFFF">
                        <tspan x="7.99631076" y="30">2021</tspan>
                    </text>
                </g>
                <line x1="25" y1="46.1406078" x2="25" y2="70.1406078" id="Line" stroke="#FFFFFF" stroke-width="1.7" opacity="0.503836496" stroke-linecap="square"></line>
            </g>
        </g>
    </g>
</svg>`;

    return (
        <i className={[styles.Main, styles.Huawei].join(' ')} dangerouslySetInnerHTML={{__html: svg}}/>
    )
}